(function () {
  var money = function (c) { return (c / 100).toLocaleString('ro-RO', { minimumFractionDigits: 2, maximumFractionDigits: 2 }) + ' lei'; };
  var drawer = document.getElementById('cart-drawer');
  var root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
  // Checkout can't open inside the theme editor frame — tell the merchant instead of silently doing nothing
  function goCheckout(btn, label) {
    if (window.Shopify && Shopify.designMode) {
      toast('Checkout-ul nu se deschide în editorul de teme. Folosește Previzualizare.');
      if (btn) { btn.disabled = false; if (label) btn.textContent = label; }
      return;
    }
    var url = root + 'checkout';
    try { if (window.top !== window.self) { window.top.location.href = new URL(url, location.href).href; return; } } catch (err) {}
    window.location.href = url;
  }
  var toastEl;
  function toast(msg) {
    if (!toastEl) { toastEl = document.createElement('div'); toastEl.className = 'toast'; document.body.appendChild(toastEl); }
    toastEl.textContent = msg; toastEl.classList.add('show');
    clearTimeout(toastEl._t); toastEl._t = setTimeout(function () { toastEl.classList.remove('show'); }, 1800);
  }
  function openDrawer() { if (!drawer) return; drawer.classList.add('open'); document.body.style.overflow = 'hidden'; }
  function closeDrawer() { if (!drawer) return; drawer.classList.remove('open'); document.body.style.overflow = ''; }

  function render(cart) {
    document.querySelectorAll('[data-cart-count]').forEach(function (el) { el.textContent = cart.item_count; });
    if (!drawer) return;
    var box = drawer.querySelector('[data-items]');
    var foot = drawer.querySelector('[data-foot]');
    if (!cart.items.length) { box.innerHTML = '<p class="empty">Coșul este gol.</p>'; foot.hidden = true; return; }
    foot.hidden = false;
    box.innerHTML = cart.items.map(function (i) {
      var img = i.image ? i.image + (i.image.indexOf('?') > -1 ? '&' : '?') + 'width=160' : '';
      return '<div class="line"><img src="' + img + '" alt="" loading="lazy" width="72" height="72">' +
        '<div class="line__info"><p class="line__title">' + i.product_title + '</p>' +
        (i.variant_title ? '<p class="mono" style="margin:4px 0 0">' + i.variant_title + '</p>' : '') +
        '<div class="qty"><button class="tap" data-q="' + i.key + '" data-v="' + (i.quantity - 1) + '" aria-label="Minus">−</button>' +
        '<span>' + i.quantity + '</span><button class="tap" data-q="' + i.key + '" data-v="' + (i.quantity + 1) + '" aria-label="Plus">+</button></div></div>' +
        '<span class="price">' + money(i.final_line_price) + '</span></div>';
    }).join('');
    drawer.querySelector('[data-total]').textContent = money(cart.total_price);
  }
  function refresh() { return fetch(root + 'cart.js').then(function (r) { return r.json(); }).then(render); }

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-open-cart]'); if (t) { e.preventDefault(); openDrawer(); return; }
    if (e.target.closest('[data-close-cart]')) { closeDrawer(); return; }
    var co = e.target.closest('[data-checkout]');
    if (co) { e.preventDefault(); co.textContent = 'Se deschide…'; goCheckout(co, 'Finalizează comanda'); return; }
    var q = e.target.closest('[data-q]');
    if (q) {
      fetch(root + 'cart/change.js', { method: 'POST', headers: { 'Content-Type': 'application/json' }, body: JSON.stringify({ id: q.dataset.q, quantity: +q.dataset.v }) })
        .then(function (r) { return r.json(); }).then(render);
      return;
    }
    var thumb = e.target.closest('[data-thumb]');
    if (thumb) {
      var main = document.querySelector('.gallery__main img');
      main.style.opacity = 0;
      setTimeout(function () { main.src = thumb.dataset.thumb; main.srcset = ''; main.style.opacity = 1; }, 150);
      thumb.parentNode.querySelectorAll('button').forEach(function (b) { b.removeAttribute('aria-current'); });
      thumb.setAttribute('aria-current', 'true');
    }
  });
  document.addEventListener('keydown', function (e) { if (e.key === 'Escape') closeDrawer(); });

  // Meta Pixel AddToCart (theme uses AJAX add, which Meta's page pixel can't see on its own)
  function fbAdd(r) {
    return r.clone().json().then(function (it) {
      if (typeof window.fbq === 'function') window.fbq('track', 'AddToCart', {
        content_ids: [String(it.variant_id)], content_name: it.product_title, content_type: 'product',
        value: it.final_line_price / 100, currency: (window.Shopify && Shopify.currency && Shopify.currency.active) || 'RON', num_items: it.quantity
      });
    }).catch(function () {}).then(function () { return r; });
  }
  document.addEventListener('submit', function (e) {
    var f = e.target.closest('form[data-add]'); if (!f) return;
    e.preventDefault();
    var buyNow = e.submitter && e.submitter.hasAttribute('data-buy-now');
    var btn = e.submitter || f.querySelector('[type=submit]');
    var data = new FormData(f);
    if (btn) btn.disabled = true;
    if (buyNow) {
      var label = btn.textContent; btn.textContent = 'Se deschide…';
      // Buy now = only this product: empty the cart first, then add it and go to checkout
      fetch(root + 'cart/clear.js', { method: 'POST', headers: { Accept: 'application/json' } })
        .then(function (r) { if (!r.ok) throw r; return fetch(root + 'cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } }); })
        .then(function (r) { if (!r.ok) throw r; return fbAdd(r); })
        .then(function () { refresh(); goCheckout(btn, label); })
        .catch(function () { toast('Nu s-a putut adăuga'); btn.disabled = false; btn.textContent = label; });
      return;
    }
    fetch(root + 'cart/add.js', { method: 'POST', body: data, headers: { Accept: 'application/json' } })
      .then(function (r) { if (!r.ok) throw r; return fbAdd(r); })
      .then(function () { return refresh(); })
      .then(function () { toast('Adăugat în coș'); if (f.hasAttribute('data-open')) openDrawer(); })
      .catch(function () { toast('Nu s-a putut adăuga'); })
      .finally(function () { if (btn) btn.disabled = false; });
  });

  // Variant picker
  var vjson = document.getElementById('variants-json');
  if (vjson) {
    var variants = JSON.parse(vjson.textContent);
    var form = document.querySelector('form[data-add]');
    form && form.addEventListener('change', function () {
      var sel = Array.prototype.map.call(form.querySelectorAll('.opts'), function (g) { var c = g.querySelector('input:checked'); return c && c.value; });
      var v = variants.find(function (x) { return x.options.every(function (o, i) { return o === sel[i]; }); });
      if (!v) return;
      form.querySelector('[name=id]').value = v.id;
      document.querySelectorAll('[data-price]').forEach(function (el) { el.textContent = money(v.price); el.setAttribute('data-amount', (v.price / 100).toFixed(2)); });
      document.querySelectorAll('[data-compare]').forEach(function (el) { if (v.compare_at_price > v.price) { el.textContent = money(v.compare_at_price); el.hidden = false; } else el.hidden = true; });
      form.querySelectorAll('[type=submit]').forEach(function (b) { b.disabled = !v.available; b.textContent = !v.available ? 'Stoc epuizat' : (b.hasAttribute('data-buy-now') ? 'Cumpără acum' : 'Adaugă în coș'); });
      if (v.featured_image) { var m = document.querySelector('.gallery__main img'); m.src = v.featured_image.src + '&width=900'; m.srcset = ''; }
    });
  }

  // Flash sale countdown — time left until local midnight, resets every day
  var cd = document.querySelector('[data-countdown]');
  if (cd) {
    var pad = function (n) { return (n < 10 ? '0' : '') + n; };
    var tick = function () {
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
      var s = Math.max(0, Math.floor((end - now) / 1000));
      cd.textContent = pad(Math.floor(s / 3600)) + ':' + pad(Math.floor(s / 60) % 60) + ':' + pad(s % 60);
    };
    tick();
    setInterval(function(){ if(!document.hidden) tick(); }, 1000);
  }

  // Scroll reveal (cheap on Android: one observer)
  if ('IntersectionObserver' in window) {
    var io = new IntersectionObserver(function (es) { es.forEach(function (x) { if (x.isIntersecting) { x.target.classList.add('in'); io.unobserve(x.target); } }); }, { rootMargin: '0px 0px -10% 0px' });
    document.querySelectorAll('.reveal').forEach(function (el) { io.observe(el); });
  } else { document.querySelectorAll('.reveal').forEach(function (el) { el.classList.add('in'); }); }

  refresh();
})();
